const TOKEN_SHAPE = /^[A-Za-z0-9_-]{20,200}$/

export function parseAccessToken(pathname: string, search: string): string | null {
  if (pathname !== '/t/access') return null
  const params = new URLSearchParams(search)
  const token = params.get('token')
  if (!token || !TOKEN_SHAPE.test(token)) return null
  return token
}

export type Zweck = 'stammdaten' | 'vertrag' | 'nachweis' | 'anwesenheitsliste'
export type StepId = 'stammdaten' | 'vertrag' | 'nachweise' | 'anwesenheitsliste'

export function isZweck(value: unknown): value is Zweck {
  return value === 'stammdaten' || value === 'vertrag' || value === 'nachweis' || value === 'anwesenheitsliste'
}

export function stepForZweck(zweck: Zweck): StepId {
  return zweck === 'nachweis' ? 'nachweise' : zweck
}

export type PortalContext = {
  zweck: Zweck
  coachingId: string

  expiresAt?: string | null
}

const CONTEXT_STORAGE_KEY = 'admination-portal-context'

export function savePortalContext(context: PortalContext): void {
  try {
    window.sessionStorage.setItem(CONTEXT_STORAGE_KEY, JSON.stringify(context))
  } catch (error) { void error }
}

export function clearPortalContext(): void {
  try {
    window.sessionStorage.removeItem(CONTEXT_STORAGE_KEY)
  } catch (error) { void error }
}

export function loadPortalContext(): PortalContext | null {
  let raw: string | null
  try {
    raw = window.sessionStorage.getItem(CONTEXT_STORAGE_KEY)
  } catch {
    return null
  }
  if (!raw) return null
  try {
    const parsed = JSON.parse(raw) as unknown
    if (
      parsed &&
      typeof parsed === 'object' &&
      typeof (parsed as PortalContext).coachingId === 'string' &&
      isZweck((parsed as PortalContext).zweck)
    ) {
      return parsed as PortalContext
    }
    return null
  } catch {
    return null
  }
}
